'use client';
import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import type { VariantType } from '../../../../types/variant';
import styles from './LotteryResultsTransfer.module.scss';
import raffleStyles from './LotteryResultsTransfer.raffle.module.scss';

export type LotteryResultsTransferProps = {
  /** 演出（scene 1 の動画再生）を開始するコールバック */
  handleStartAnimation: () => void;
  /** スタイルのバリアント（オプション） */
  variant?: VariantType;
};

// 演出開始前の transfer シーン。ボタン押下（ユーザー操作）で scene 1 の動画再生を開始し、自動再生制約を回避する。
// video の自動再生制約を回避するため、ユーザーのボタン押下を起点に演出を開始する。
function LotteryResultsTransfer({ handleStartAnimation, variant = 'default' }: LotteryResultsTransferProps) {
  const currentStyles = variant === 'raffle' ? raffleStyles : styles;

  return (
    <div className={currentStyles.container}>
      <img className={currentStyles.logo} src='/logo.png' alt='Loading' />
      <div className={currentStyles.button}>
        <ActionButton variant={variant} color='black' size='large' onClick={handleStartAnimation}>
          くじ引き結果を見る
        </ActionButton>
      </div>
    </div>
  );
}

export default LotteryResultsTransfer;
